<template>
  <a-form-item :label="label" :required="required">
    <a-select
      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      v-model:value="selected"
      class="select"
      placeholder="Seleccionar tipo de estrategia"
    >
      <a-select-option :key="0" v-if="showAll">Todos los tipos</a-select-option>
      <a-select-option v-for="item in types" :key="item.id">
        {{ item.name }}
      </a-select-option>
    </a-select>
  </a-form-item>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Number,
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    label: {
      required: false,
      type: String,
      default: "",
    },
    showAll: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    types() {
      // Muestra SMS
      // return this.$store.getters["getStrategyTypeList"];

      // Hidden SMS for PoC
      return this.$store.getters["getStrategyTypeList"];
    },
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
  },
};
</script>

<style lang="sass" scoped>
.select
  min-width: 180px
  width: 100%
</style>
